import { SegmentedControlBadge } from './SegmentedControlBadge'
import { SegmentedControlContent } from './SegmentedControlContent'
import { SegmentedControlDescription } from './SegmentedControlDescription'
import { SegmentedControlHeading } from './SegmentedControlHeading'
import { SegmentedControlIcon } from './SegmentedControlIcon'
import { SegmentedControlItem } from './SegmentedControlItem'
import { SegmentedControlItemList } from './SegmentedControlItemList'
import { SegmentedControlRoot } from './SegmentedControlRoot'

export const SegmentedControl = {
  Root: SegmentedControlRoot,
  Item: SegmentedControlItem,
  Heading: SegmentedControlHeading,
  Description: SegmentedControlDescription,
  Icon: SegmentedControlIcon,
  Content: SegmentedControlContent,
  Badge: SegmentedControlBadge,
  ItemList: SegmentedControlItemList
}
